import type { Stripe } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useEffect, useState } from 'react';

import type { Publication } from '~/interfaces/publication';

import { getAppGlobals } from '~/components/AppGlobals/utils';

interface Props {
  publication: Publication;
  isInternalCheckout: boolean;
}

const initStripe = (publishableKey: string, stripeAccountId: string) => {
  return loadStripe(publishableKey, {
    stripeAccount: stripeAccountId,
  });
};

const useSubscriberCheckout = ({ publication }: Props) => {
  const [isLoadingStripeSession, setIsLoadingStripeSession] = useState(true);
  const [stripeSession, setStripeSession] = useState<Stripe | null>(null);

  const getAndSetStripeSession = async () => {
    const appGlobals = getAppGlobals();
    try {
      setIsLoadingStripeSession(true);
      // biome-ignore lint/style/noNonNullAssertion: Keeping for backwards compatibility
      const session = await initStripe(appGlobals.STRIPE_PUBLISHABLE_KEY, publication.stripe_user_id ?? '');
      setStripeSession(session);
    } catch (error: any) {
      // todo: hand stripe session error
      console.error(error);
    }

    setIsLoadingStripeSession(false);
  };

  useEffect(() => {
    if (!stripeSession && window) {
      getAndSetStripeSession();
    }
  }, [stripeSession]);

  return {
    isLoadingStripeSession,
    stripeSession,
  };
};

export default useSubscriberCheckout;
